<template>
  <div id="holacon-live-login-screen">
    <div class="login-screen-background">
      <div class="login-screen-panel">
        <div class="login-screen-panel-form">
          <div class="form-header-container">
            <h1>{{ $t("forgot.forgot") }}</h1>
            <p>{{ $t("forgot.desc") }}</p>
          </div>

          <div class="form-inputs-container" @keydown.enter.exact.prevent @keyup.enter.exact="forgot">
            <div class="custom-input email icon" :class="(sent ? 'disabled' : '') + hasError('email')">
              <label>{{ $t("forgot.email") }}</label>
              <el-input placeholder="..." v-model="form.email" :disabled="sent" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-envelope"></i></el-input>
              <span class="md-error">{{ errorMessage("email") }}</span>
            </div>

            <div
              class="forgot-pwd-button"
              v-if="sent"
              @click="
                forgot();
                form.resetToken = '';
                enterResetCode = false;
              "
            >
              {{ $t("forgot.resend") }}
            </div>

            <div class="custom-input text icon" :class="hasError('resetToken')" v-if="sent">
              <label>{{ $t("forgot.resetToken") }}</label>
              <el-input placeholder="..." v-model="form.resetToken" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''"><i slot="prefix" class="fas fa-key"></i></el-input>
              <span class="md-error">{{ errorMessage("resetToken") }}</span>
            </div>

            <div class="custom-input password icon" :class="hasError('password')" v-if="sent">
              <label>{{ $t("forgot.password") }}</label>
              <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="form.password" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                <i slot="prefix" class="fas fa-lock"></i>
                <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
              </el-input>
              <span class="md-error">{{ errorMessage("password") }}</span>
            </div>

            <div class="custom-input password icon" :class="hasError('passwordRetry')" v-if="sent">
              <label>{{ $t("forgot.passwordRetry") }}</label>
              <el-input :type="showpwd != true ? 'password' : 'text'" placeholder="..." v-model="form.passwordRetry" v-on:input="response.validationErrors.length ? (response.validationErrors = []) : ''">
                <i slot="prefix" class="fas fa-lock"></i>
                <i slot="suffix" class="fa show-pwd" :class="showpwd != true ? 'fa-eye' : 'fa-eye-slash'" @click="showpwd = !showpwd"></i>
              </el-input>
              <span class="md-error">{{ errorMessage("passwordRetry") }}</span>
            </div>

            <div class="form-confirm">
              <el-button type="primary" :loading="isLoading" :disabled="isLoading" @click="sent ? reset() : forgot()">{{ !isLoading ? $t("forgot.forgot") : $t("wait") }}</el-button>
            </div>

            <div class="form-confirm pt-0 visible-xs">
              <button class="outline mono" @click="$router.push({ name: 'register' })">{{ $t("register.register") }}</button>
            </div>

            <div class="forgot-pwd-button">
              <router-link :to="{ name: 'login' }">{{ $t("login.login") }}</router-link>
            </div>
          </div>

          <div class="download-app visible-xs">
            <h3>{{ $t("login.downloadapp") }}</h3>
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>

        <div class="login-screen-panel-salute bg-3">
          <div class="login-logo-area" :class="$route.params.slug != 'holacon' ? 'has-whitelabel' : ''">
            <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="whitelabel-logo" />
            <img v-else src="/static/logo-light.svg" class="logo" />
          </div>

          <div class="salute-container">
            <h1>{{ $t("forgot.title") }}</h1>
            <p>{{ $t("forgot.description") }}</p>
          </div>

          <div class="form-confirm hidden-xs">
            <button class="button-light" @click="$router.push({ name: 'register' })">{{ $t("register.register") }}</button>
          </div>

          <div class="download-app hidden-xs">
            <a target="_blank" :href="$store.state.application.iosLink" v-if="$store.state.application.iosLink != null">
              <img src="/static/apple.png" alt="download" />
            </a>
            <a target="_blank" :href="$store.state.application.androidLink" v-if="$store.state.application.androidLink != null">
              <img src="/static/google.png" alt="download" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <md-snackbar :class="response.hasError ? 'warning' : 'success'" :md-position="'center'" :md-duration="4000" :md-active.sync="response.hasError" md-persistent>
      <i class="fa" :class="response.hasError ? 'fa-exclamation-triangle' : 'fa-check'"></i>
      <span>{{ response.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      sent: false,
      form: {
        email: null,
        password: null,
        passwordRetry: null,
        resetToken: null,
        isLive: true
      },
      isLoading: false,
      showpwd: false,
      enterResetCode: false,
      isError: false,
      timeout: null,
      loading: false,
      response: {
        hasError: false,
        message: null,
        validationErrors: []
      }
    };
  },
  created() {
    if (this.$route.query.code != undefined && this.$route.query.code != null) {
      this.sent = true;
      this.form.resetToken = this.$route.query.code;
      this.form.email = this.$route.query.email;
    }
  },
  methods: {
    async forgot() {
      this.isLoading = true;

      var response = await axios.post("login/forgotpassword", this.form);
      this.response.validationErrors = response.data.validationErrors;
      if (!response.data.hasError) {
        this.sent = true;
        this.$message.success(response.data.message);
      } else {
        this.$message.error(response.data.message);
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async reset() {
      this.isLoading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var resetResponse = await axios.post("login/resetpassword", this.form);
        this.response.validationErrors = resetResponse.data.validationErrors;
        if (!resetResponse.data.hasError) {
          var loginResponse = await axios.post("login/signin", this.form);
          if (!loginResponse.data.hasError) {
            this.$store.commit("setToken", loginResponse.data.data.token);
            var userResponse = await axios.post("account/get");
            this.$store.commit("setUser", userResponse.data.data.user);
            this.$store.commit("setNotify", userResponse.data.data);
            localStorage.setItem("token", loginResponse.data.data.token);
            this.$router
              .push({
                name: "home",
                params: { slug: this.$route.params.slug }
              })
              .catch(e => {});
          } else {
            this.$message.error(loginResponse.data.message);
          }
        } else {
          this.$message.error(resetResponse.data.message);
        }
      }, 500);

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    hasError(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return "md-invalid";
      } else {
        return "";
      }
    },
    errorMessage(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return this.response.validationErrors.find(k => k.key == key).value;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="less">
#login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .left {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      width: 230px;
    }
  }

  .right {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .form {
      width: 400px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .md-field {
        margin-bottom: 20px;
      }

      .action-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
    }
  }

  .welcome {
    max-width: 450px;
  }
}

@media (max-width: 768px) {
  #login {
    flex-direction: column;
    height: 100vh;
    overflow: auto;
    display: block;

    .left,
    .right {
      width: 100%;
      padding: 0px 30px;
    }

    .title {
      line-height: 35px;
    }
  }

  .back_button {
    margin: 0;

    .md-ripple {
      justify-content: flex-start;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue